<template>
  <AssetTypeVideo />
  <div
    class="container h-100 d-flex align-items-center justify-content-center z-2"
  >
    <div class="row mobile align-content-between g-0">
      <TypeTopNav :heading="this.assetType" />

      <div class="col-12 d-flex align-items-center justify-content-center z-2">
        <div class="row g-0">
          <div class="col-12">
            <template v-for="(asset, index) in assetTypes" :key="asset.Guid">
              <div
                v-if="asset.LinkName.includes('walkthrough')"
                v-on:click="navigate(asset, collection, index)"
                :class="[
                  'btn-theme-menu',
                  'mb-2',
                  {
                    'border-bottom-left': index === assetTypes.length - 1,
                    'border-top-right': index === 0,
                  },
                ]"
              >
                {{ asset.ObjectName }}
              </div>

              <!-- Panorama links -->
              <router-link
                v-if="asset.LinkName.includes('tour')"
                :to="{
                  name: 'AssetViewDetail',
                  params: {
                    assetType: this.assetType,
                    viewType: asset.LinkName,
                    order: 0,
                  },
                }"
                :class="[
                  'btn-theme-menu',
                  'mb-2',
                  {
                    'border-bottom-left': index === assetTypes.length - 1,
                    'border-top-right': index === 0,
                  },
                ]"
              >
                {{ asset.ObjectName }}
              </router-link>
            </template>
          </div>
        </div>
      </div>

      <TypeBotNav />
    </div>
  </div>
  <OffCanvas />
</template>

<script>
import AssetTypeVideo from "@/components/AssetTypeVideo.vue";
import TypeTopNav from "@/components/TypeTopNav.vue";
import TypeBotNav from "@/components/TypeBotNav.vue";
import OffCanvas from "@/components/OffCanvas.vue";
import global from "../global";
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";
import sortArray from "sort-array";

export default {
  name: "AssetType",
  props: {
    assetType: String,
  },
  components: {
    AssetTypeVideo,
    TypeTopNav,
    TypeBotNav,
    OffCanvas,
  },
  data() {
    return {
      assetTypes: null,
      collection: null,
      componentName: "AssetViewDetail",
      folderStructure: encodeURIComponent(
        this.theme.devFolder + "/assets/type1/" + this.assetType + "/"
      ),
      assetOrder: null,
    };
  },
  methods: {
    navigate(asset, collection, index) {
      // set library and collection ids
      this.lid = collection.videoLibraryId;
      this.collectionId = collection.guid;
      BunnyNetService.getVideos(this.lid, this.collectionId)
        .then((response) => {
          // Remap array (inject asset names)
          console.log(response.data);
          let j = 0;
          const menuItems = response.data.items.map((item) => {
            return {
              guid: item.guid,
              videoLibraryId: item.videoLibraryId,
              thumbnailFileName: item.thumbnailFileName,
              ObjectName: item.ObjectName,
              title: item.title,
              id: j++,
            };
          });
          let navigateData = menuItems.find((item) =>
            item.title.includes(asset.LinkName)
          );

          this.$router.push({
            path: `/asset/view/video/${navigateData.videoLibraryId}/${navigateData.guid}`,
          });
          this.videoStatus = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },

  created() {
    BunnyNetService.getFolders(this.folderStructure)
      .then((response) => {
        // Remap array
        const menuItems = response.data.map((item) => {
          return {
            Guid: item.Guid,
            ObjectName: unslugify(item.ObjectName),
            LinkName: item.ObjectName,
            ComponentName: this.componentName,
            Path: item.Path,
            IsDirectory: item.IsDirectory,
            StorageZoneName: item.StorageZoneName,
          };
        });
        // Assign type menu array
        console.log(this.assetType);
        console.log(menuItems);
        if (this.assetType == "type-c-360-tour") {
          this.assetOrder = this.theme.tour;
        } else {
          this.assetOrder = this.theme.walkthrough;
        }

        // Sort array
        const customMenu = sortArray(menuItems, {
          by: ["LinkName"],
          order: "LinkName",
          customOrders: {
            LinkName: this.assetOrder,
          },
        });
        this.assetTypes = customMenu;
        console.log(this.assetTypes);
      })
      .catch((error) => {
        console.log(error);
      });
    // api call get video collection details
    BunnyNetService.getCollections(this.theme.videoLibraryId, this.assetType)
      .then((response) => {
        this.collection = response.data[0];
      })
      .catch((error) => {
        console.log(error);
      });
  },
  setup() {
    // load global config
    const { theme } = global;

    return {
      theme,
    };
  },
};
</script>
